export const FAQData = [
  {
    id: 1,
    question: "What is the mission of this Madrasah?",
    answer: {
      text: "Our mission is to provide high-quality Islamic education to females and children globally in a safe, accessible, and interactive online environment. We aim to empower students with Islamic knowledge, Arabic language skills, and Quranic studies to strengthen their faith and spirituality.",
    },
  },
  {
    id: 2,
    question: "Who can enroll in this Madrasah?",
    answer: {
      text: "Our online Madrasah is open to females and children of all ages. We offer classes tailored specifically for girls, young women, and children across different learning levels.",
    },
  },
  {
    id: 3,
    question: "How are classes conducted?",
    answer: {
      text: "All our classes are conducted online via live video sessions and interactive learning tools. Each class is led by qualified female instructors experienced in teaching children and females.",
    },
  },
  {
    id: 4,
    question: "What is the duration of each class or course?",
    answer: {
      text: "Class durations vary depending on the course. Generally, each class lasts between 30 MINUTES to 2 HOURS 30 minutes , and the duration of the entire course can range from a few weeks to several months based on the level and subject.",
    },
  },
  {
    id: 5,
    question: "What subjects are offered in this Madrasah?",
    answer: {
      text: "We provide a comprehensive range of subjects including:",
      points: [
        "Quranic Studies (Tajweed, memorization, recitation)",
        "Islamic Studies (Aqeedah, Fiqh, Seerah)",
        "Arabic Language (Grammar, reading, writing)",
        "Hadith and Tafsir",
        "Islamic Etiquette and Morals",
      ],
    },
  },
  {
    id: 6,
    question: "How do I register my child or myself for a course?",
    answer: {
      text: "You can register by visiting our Registration Page and filling out the enrollment form. Once submitted, you will receive a confirmation email with further instructions on payment and class details.",
    },
  },
  {
    id: 7,
    question: "Are the instructors female?",
    answer: {
      text: "Yes, all of our instructors are qualified female teachers who have been vetted for their knowledge, teaching skills, and experience in educating females and children.",
    },
  },
  {
    id: 8,
    question: "What is the class schedule like?",
    answer: {
      text: "We offer flexible schedules to accommodate students in various time zones. Upon enrollment, you will be able to select a class schedule that suits your availability.",
    },
  },
  {
    id: 9,
    question: "What is the duration of each class or course?",
    answer: {
      text: "Class durations vary depending on the course. Generally, each class lasts between 30 MINUTES to 2 HOURS 30 minutes , and the duration of the entire course can range from a few weeks to several months based on the level and subject.",
    },
  },
  {
    id: 10,
    question: "Can students from any country join the Madrasah?",
    answer: {
      text: "Yes! We welcome female students and children from all over the world. Our classes are designed to be accessible to students in different time zones.",
    },
  },
];
